import { Combobox } from "@msuite/ui/form";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ProjectContactFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useContacts } from "@/hooks/use-contacts";
import { AddContactModal } from "@/modals/contacts/add-contact-modal";
import { ProjectContactMembers } from "./project-contact-members";

/** Props Interface */
interface ProjectContactFormProps {
	contactIsDisabled: boolean;
}

export function ProjectContactForm({ contactIsDisabled }: ProjectContactFormProps) {
	/** Context */
	const methods = useFormContext<ProjectContactFormSchema>();
	const contactId = useWatch({ control: methods.control, name: "contactId" });

	/** Hooks */
	const addContactMember = useDisclosure();
	const { t } = useTranslation();

	/** Query */
	const { contacts } = useContacts();

	/** Render */
	return (
		<React.Fragment>
			<div className="v-stack">
				<div className="max-w-[400px]">
					<Combobox
						control={methods.control}
						name="contactId"
						options={contacts}
						displayValue={(item) => item.name}
						label={t("contacts.contact")}
						keyExtractor={(item) => item.id}
						placeholder={t("placeholders.company_name")}
						isRequired={false}
						data-cy="project-contact-input"
						isDisabled={contactIsDisabled}
						middleware={() => {
							methods.setValue("contactMemberIds", []);
						}}
						buttons={[
							{
								tags: ["add", "add contact"],
								onClick: () => {
									addContactMember.onOpen();
								},
								render: () => (
									<div className="h-stack">
										<Icon name="Plus" />
										<p>{t("contacts.add_contact")}</p>
									</div>
								),
							},
						]}
					/>
				</div>
				<ProjectContactMembers contactId={contactId} />
			</div>
			<AddContactModal
				isOpen={addContactMember.isOpen}
				onClose={addContactMember.onClose}
				onComplete={(contact) => {
					methods.setValue("contactId", contact.id);
				}}
			/>
		</React.Fragment>
	);
}
